import React, { useState } from "react";
import { PiEyeSlashLight, PiEyeThin } from "react-icons/pi";
import toast from "react-hot-toast";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordConfirmationVisible, setPasswordConfirmationVisible] =
    useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length < 8) {
      toast.error("Password must be at least 8 characters long.");
      return;
    }

    if (password !== passwordConfirmation) {
      toast.error("Passwords do not match.");
      return;
    }

    setLoading(true);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: "",
        password,
        password_confirmation: passwordConfirmation,
      }),
    };

    try {
      const response = await fetch(
        "https://backend.pmc-group.uk/api/reset_password/65c553e5e5a5ba376ccb99b01379a7e9f5b00e5c?expires=1730308479&signature=c33bdeab6559392552e863efc3b5e76bbc0fd02c8ee7a54d81a83da3962bf005",
        requestOptions
      );
      const result = await response.json();

      if (response.ok) {
        toast.success("Password reset successfully.");
        setPassword("");
        setPasswordConfirmation("");
      } else {
        toast.error(result.message || "Something went wrong.");
      }
    } catch (error) {
      toast.error("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <Toaster /> */}
      <div className="flex justify-center px-4">
        <div className="relative flex w-full max-w-md flex-col space-y-5 rounded-lg mt-8 mb-14 border bg-white px-5 py-6 shadow-xl sm:mx-auto">
          <div className="mx-auto mb-2 space-y-3">
            <h1 className="text-center text-3xl font-bold text-gray-700">
              Reset Password
            </h1>
            <p className="text-gray-500">
              Enter your new password to reset your account for <span className="font-Poppins text-blue-600 font-semibold">PMC</span>.
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div>
              <div className="relative mt-2 w-full">
                <input
                  type={passwordVisible ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="peer block w-full appearance-none rounded-lg border border-gray-300 bg-transparent px-2.5 pt-4 pb-2.5 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0"
                  placeholder=" "
                  required
                />
                <label
                  htmlFor="password"
                  className="absolute left-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform cursor-text select-none bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600"
                >
                  New Password
                </label>
                <div
                  onClick={() => setPasswordVisible(!passwordVisible)}
                  className="absolute top-4 right-2 cursor-pointer"
                >
                  {passwordVisible ? <PiEyeThin /> : <PiEyeSlashLight />}
                </div>
              </div>
            </div>

            <div>
              <div className="relative mt-4 w-full">
                <input
                  type={passwordConfirmationVisible ? "text" : "password"}
                  value={passwordConfirmation}
                  onChange={(e) => setPasswordConfirmation(e.target.value)}
                  className="peer block w-full appearance-none rounded-lg border border-gray-300 bg-transparent px-2.5 pt-4 pb-2.5 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0"
                  placeholder=" "
                  required
                />
                <label
                  htmlFor="passwordConfirmation"
                  className="absolute left-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform cursor-text select-none bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600"
                >
                  Confirm Password
                </label>
                <div
                  onClick={() =>
                    setPasswordConfirmationVisible(!passwordConfirmationVisible)
                  }
                  className="absolute top-4 right-2 cursor-pointer"
                >
                  {passwordConfirmationVisible ? <PiEyeThin /> : <PiEyeSlashLight />}
                </div>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="shrink-0 mt-6 inline-block w-full rounded-lg bg-blue-500 py-3 text-sm font-bold text-white transition hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
